export const imageRegex = /[/.](gif|jpg|jpeg|tiff|png|pdf)$/i;

export const fileRegEx =
  /[/.](gif|jpg|jpeg|tiff|png|pdf|doc|docx|xls|xlsx|ppt|pptx|txt|bmp|eps|xps|rtf|csv)$/i;

export const excelRegEx = /[/.](csv)$/i;
